import React from 'react';

import { S3_BUCKET } from '@/utility/constants';
import { t } from '@/utility/localization';

import AdvancedImageUpload from '@/components/common/Form/AdvancedImageUpload/AdvancedImageUpload';
import Icon from '@/components/npl/Icon';

const THUMBNAIL_UPLOAD_PATH = `nasIO/community-folder/folder-item-thumbnails/`;

const FolderItemThumbnail = (props) => {
  const {
    thumbnailSrc,
    showRemoveOption,
    handleImgChange,
    showEditIconOnOverlay,
    showEditIconOnBottomRight
  } = props;

  return (
    <div>
      <AdvancedImageUpload
        uploadHint={t('recommended-size-720x720')}
        previewSize={{
          width: '60px',
          height: '60px'
        }}
        bucket={S3_BUCKET}
        path={THUMBNAIL_UPLOAD_PATH}
        value={thumbnailSrc}
        removeButtonLabel={showRemoveOption ? t('remove-thumbnail') : ''}
        onInput={(imgSrc) => {
          handleImgChange(imgSrc);
        }}
        renderCustomUI={({ openModal }) => {
          return (
            <div
              className="group/thumbnail relative mr-16 h-[60px] w-[60px] flex-shrink-0 rounded-12"
              role="button"
              tabIndex={0}
              onClick={openModal}>
              <img
                src={thumbnailSrc}
                alt="thumbnail"
                className="h-[60px] w-[60px] rounded-12 object-cover"
              />

              {/* Edit Thumbnail Overlay */}
              <button
                type="button"
                className="absolute bottom-0 left-0 right-0 top-0 hidden flex-col items-center justify-center space-y-2 rounded-4 bg-dark-50 group-hover/thumbnail:flex">
                {showEditIconOnOverlay && (
                  <Icon
                    name="pencil-01"
                    width={20}
                    height={20}
                    fill="#F5F5F5"
                  />
                )}

                <p className="text-label-sm font-medium text-npl-text-primary-on-dark">
                  {t('edit')}
                </p>
              </button>
              {showEditIconOnBottomRight && (
                <div className="absolute bottom-[-16px] right-[-16px] flex h-32 w-32 cursor-pointer items-center justify-center rounded-full bg-npl-neutral-light-solid-3">
                  <Icon name="pencil-01" width={16} height={16} />
                </div>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default FolderItemThumbnail;
